export { };
declare global {

  interface Array<T> {
    anyChecked(propCheck: string): boolean;
    sortBy(propToSort: string): Array<T>;
    sortByDesc(propToSort: string): Array<T>;
  }
}



Array.prototype.anyChecked = function(propCheck: string) {
  const _self = this as Array<string>;
  if (_self == undefined) {
return false;
}
  let any = false;
  any = _self.some(el => (el[propCheck]));
  return any;
};

Array.prototype.sortBy = function(propToSort: string) {
  return this.sort((a, b) => {
    if (a[propToSort] < b[propToSort]) {
return -1;
} else if (a[propToSort] > b[propToSort]) {
return 1;
} else {
return 0;
}
  });
};

Array.prototype.sortByDesc = function(propToSort: string) {
  return this.sort((a, b) => {
    if (a[propToSort] < b[propToSort]) {
return 1;
} else if (a[propToSort] > b[propToSort]) {
return -1;
} else {
return 0;
}
  });
};
